// Union de string literals pour externalStatus
export type ExternalStatus =
	| 'NOT_IMPORTED'
	| 'IMPORTED'
	| 'MANUALLY_LINKED'
	| 'IGNORED';

// Constante pour options du select
export const STATUS_OPTIONS: ExternalStatus[] = [
	'NOT_IMPORTED',
	'IMPORTED',
	'MANUALLY_LINKED',
	'IGNORED',
];
